// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"8f53cd1f","106":"66b6d20b","426":"35a8d4a1","477":"aae84ca8","498":"bb659696","552":"211d15fb","557":"584bf2cf","585":"728441c1","602":"be444ee5","798":"6821d230","905":"9d488ad4"}[chunkId] + ".chunk.js";
};